/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SupplierAttributeValue
 */
export interface SupplierAttributeValue {
  /**
   *
   * @type {string}
   * @memberof SupplierAttributeValue
   */
  value: string
  /**
   *
   * @type {number}
   * @memberof SupplierAttributeValue
   */
  createdAt: number
  /**
   *
   * @type {number}
   * @memberof SupplierAttributeValue
   */
  updatedAt: number
}

/**
 * Check if a given object implements the SupplierAttributeValue interface.
 */
export function instanceOfSupplierAttributeValue(
  value: object,
): value is SupplierAttributeValue {
  if (!('value' in value) || value['value'] === undefined) return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function SupplierAttributeValueFromJSON(
  json: any,
): SupplierAttributeValue {
  return SupplierAttributeValueFromJSONTyped(json, false)
}

export function SupplierAttributeValueFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SupplierAttributeValue {
  if (json == null) {
    return json
  }
  return {
    value: json['value'],
    createdAt: json['createdAt'],
    updatedAt: json['updatedAt'],
  }
}

export function SupplierAttributeValueToJSON(
  json: any,
): SupplierAttributeValue {
  return SupplierAttributeValueToJSONTyped(json, false)
}

export function SupplierAttributeValueToJSONTyped(
  value?: SupplierAttributeValue | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    value: value['value'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
  }
}
